export default __webpack_public_path__ + "static/media/main_logo.862fc223.png";